class FirebaseConst {
	public static readonly RESET_PASSWORD: string = "resetPassword";
	public static readonly VERIFY_ACCOUNT: string = "verifyEmail";
}

export default FirebaseConst;
